import Reveal from "@/components/Reveal";
import { ArrowUpRight, Mail, Linkedin, CalendarClock } from "lucide-react";

export default function ContactSection() {
  return (
    <section id="contact" className="bg-[#09090B] border-t border-[#F3F0E8]/10 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-24 sm:py-36">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-[#CFE9EF]/70">contact</p>
            <h2
              data-testid="contact-heading"
              className="font-serif-d font-black tracking-tight leading-[1.0] text-4xl sm:text-6xl lg:text-7xl text-[#F3F0E8] mt-6"
            >
              Let's see if it's{" "}
              <span className="italic font-semibold text-[#F3F0E8]/45 whitespace-nowrap">a fit.</span>
            </h2>
            <p className="text-base sm:text-lg text-[#F3F0E8]/60 leading-relaxed mt-8 max-w-md">
              I take on a small number of clients at a time, so every
              engagement begins with a conversation about fit — what you want
              to be known for, and where your presence stands today.
            </p>
            <div className="mt-12 space-y-4">
              <p className="flex items-center gap-3 mb-6" data-testid="contact-availability">
                <span className="w-1.5 h-1.5 rounded-full bg-[#118C4F] animate-pulse-dot" aria-hidden="true" />
                <span className="text-[10px] uppercase tracking-[0.25em] text-[#CFE9EF]/80">
                  Clients across time zones · Limited new engagements
                </span>
              </p>
              <p className="flex items-center gap-3">
                <Mail size={14} className="text-[#118C4F] shrink-0" aria-hidden="true" />
                <a href="mailto:heybaishali@gmail.com" data-testid="contact-email-link" className="text-xs uppercase tracking-[0.25em] text-[#F3F0E8]/45 hover:text-[#CFE9EF] transition-colors">
                  Email — <span className="text-[#F3F0E8]/80">heybaishali@gmail.com</span>
                </a>
              </p>
              <p className="flex items-center gap-3">
                <Linkedin size={14} className="text-[#118C4F] shrink-0" aria-hidden="true" />
                <a href="https://www.linkedin.com/in/iambaishali/" target="_blank" rel="noopener noreferrer" data-testid="contact-linkedin-link" className="text-xs uppercase tracking-[0.25em] text-[#F3F0E8]/45 hover:text-[#CFE9EF] transition-colors">
                  LinkedIn — <span className="text-[#F3F0E8]/80">/in/iambaishali</span>
                </a>
              </p>
              <p className="flex items-center gap-3">
                <CalendarClock size={14} className="text-[#118C4F] shrink-0" aria-hidden="true" />
                <a href="https://calendly.com/iambaishali" target="_blank" rel="noopener noreferrer" data-testid="contact-booking-link" className="text-xs uppercase tracking-[0.25em] text-[#F3F0E8]/45 hover:text-[#CFE9EF] transition-colors">
                  Booking — <span className="text-[#F3F0E8]/80">calendly.com/iambaishali</span>
                </a>
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="border border-[#F3F0E8]/12 hover:border-[#118C4F]/50 transition-colors duration-500 p-10 sm:p-14 lg:mt-16">
              <p className="text-[10px] uppercase tracking-[0.3em] text-[#118C4F]">step one</p>
              <h3 className="font-serif-d font-black tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#F3F0E8] mt-5 leading-[1.05]">
                Every engagement starts with a{" "}
                <span className="italic font-semibold text-[#F3F0E8]/50">discover call.</span>
              </h3>
              <p className="text-sm sm:text-base text-[#F3F0E8]/60 leading-relaxed mt-6 max-w-md">
                A short, direct conversation. You bring where things stand —
                I'll bring an honest first read on what I'd do about it, and
                whether I'm the right person to do it.
              </p>
              <a
                href="https://calendly.com/iambaishali"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="book-discover-call-button"
                className="group inline-flex items-center gap-2 bg-[#118C4F] hover:bg-[#F3F0E8] text-[#F3F0E8] hover:text-[#09090B] font-medium px-8 py-4 mt-10 transition-colors duration-300"
              >
                Book a discover call
                <ArrowUpRight size={17} strokeWidth={2.2} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </a>
              <p className="text-xs text-[#F3F0E8]/40 mt-6">
                Prefer writing first?{" "}
                <a href="mailto:heybaishali@gmail.com" className="text-[#118C4F] hover:text-[#CFE9EF] underline underline-offset-4 transition-colors">
                  Email me instead
                </a>
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
